import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { PartenaireRoutingModule } from './partenaire-routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DepotComponent } from './depot/depot.component';
import { RetraitComponent } from './retrait/retrait.component';
import { NouveaupartenaireComponent } from './nouveaupartenaire/nouveaupartenaire.component';
import { FirstLoginActivationComponent } from './first-login-activation/first-login-activation.component';

@NgModule({
  declarations: [
    DashboardComponent,
    DepotComponent,
    RetraitComponent,
    NouveaupartenaireComponent,
    FirstLoginActivationComponent
  ],
  imports: [SharedModule, PartenaireRoutingModule]
})
export class PartenaireModule { }
